import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slides-tall-add"} maskId="square-filled-radius-0-stroke-1-IconSlidesTallAdd"><path fillRule="evenodd" clipRule="evenodd" d="M4 19V2H17V5H20V22H7V19H4ZM16 3V5H7V18H5V3H16ZM14 10H13V13H10V14H13V17H14V14H17V13H14V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlidesTallAdd;
